<template>
  <div>
    <v-toolbar color="primary" dark app>
      <v-toolbar-side-icon
        v-if="$route.meta.mostraSideMenu"
        @click="menuLateral = !menuLateral"
      ></v-toolbar-side-icon>
      <img
        height="65"
        @click="getCurrentUser() ? go('/portal') : go('/login')"
        class="pointer"
        :src="require('@/assets/logo-negativo.png')"
      />
      <v-spacer></v-spacer>
      <v-btn
        v-if="getCurrentUser() && this.$route.path !== '/login'"
        :disabled="
          usuarioLogado.idtipousuario == perfilUsr.ID.operador ||
          usuarioLogado.idtipousuario == perfilUsr.ID.franquiado || 
          usuarioLogado.idtipousuario == perfilUsr.ID.clienteMetta
        "
        @click="abrirModal()"
        color="white"
        flat
        class="hidden-sm-and-down default-border"
        >{{ usuarioLogado.nomeconta }}</v-btn
      >

      <v-btn
        v-if="!getCurrentUser() && this.$route.path !== '/login'"
        @click="go('/login')"
        color="white"
        flat
        class="hidden-sm-and-down default-border"
        >Fazer Login</v-btn
      >
      <v-menu
        v-if="!getCurrentUser() && this.$route.path !== '/login'"
        class="hidden-md-and-up"
        bottom
        left
      >
        <v-btn slot="activator" dark icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="go('/login')">
            <v-list-tile-title>Fazer Login</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <div>
        <v-dialog v-model="dialog" @mousedown="close()">
          <v-card>
            <v-card-title class="pt-0">
              <span class="headline pb-0">Selecione a franquia </span>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">Fechar</v-btn>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-form
                v-model="formularioCadastroValido"
                ref="formularioCadastroRef"
              >
                <v-container grid-list-md class="pa-0">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 md4>
                        <v-select
                          v-model="cadastroModel.conta"
                          color="secondary"
                          :rules="regras.nome"
                          :items="listaContas"
                          item-text="nome"
                          prepend-icon="account_balance"
                          label="Franquia"
                          required
                          return-object
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 md4>
                        {{ notificao }}
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      class="grey--text text--darken-1"
                      @click="close"
                      flat
                      >Voltar</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      class="default-border"
                      depressed
                      :disabled="disableBtnFinalizar || !formValid"
                      @click="finalizar"
                      >Finalizar</v-btn
                    >
                  </v-card-actions>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-toolbar>
    <SideMenu
      v-if="$route.meta.mostraSideMenu"
      v-model="menuLateral"
    ></SideMenu>
  </div>
</template>

<script>
import usuarioHelper from "@/helpers/usuario.js";
import SideMenu from "@/components/compartilhados/SideMenu";
import perfil from "@/helpers/perfil.js";
import jwt from "@/helpers/jwt";

export default {
  name: "Toolbar",
  data: () => {
    return {
      currentPath: "",
      menuLateral: false,
      dialog: false,
      formularioCadastroValido: false,
      disableBtnFinalizar: false,
      listaContas: null,
      notificao: "",
      cadastroModel: { conta: null },
      regras: {
        nome: [(v) => !!v || "Você não pode deixar este campo em branco"],
      },
      getCurrentUser() {
        if (
          JSON.parse(localStorage.getItem("token")) == null &&
          !this.$route.meta.mostraSideMenu
        ) {
          this.menuLateral = false;
        }
        return JSON.parse(localStorage.getItem("token"));
      },
    };
  },
  components: {
    SideMenu,
  },
  computed: {
    formValid: function () {
      return this.formularioCadastroValido;
    },
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },
    perfilUsr: function () {
      return perfil;
    },
  },
  watch: {
    dialog(val) {
      const self = this;
      if (!val) {
        self.close();
      }
    },
  },
  methods: {
    buscaContas() {
      const self = this;
      self.$http
        .get(`${process.env.URL_API}/conta/v1/busca/ativa`, {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("token")),
          },
        })
        .then(function (response) {
          self.listaContas = response.data;
          self.listaContas.sort(self.compareNome);
        });
    },
    abrirModal() {
      const self = this;
      self.buscaContas();
      self.dialog = true;
    },
    finalizar: function () {
      const self = this;
      if (self.$refs.formularioCadastroRef.validate()) {
        const item = jwt.decryptToken();
        if (item != null) {
          self.$http
            .get(
              `${process.env.URL_API}/usuario/v1/troca/usuario/` +
                jwt.decryptToken().id +
                `/conta/` +
                self.cadastroModel.conta.idConta,
              {
                headers: {
                  Authorization:
                    "Bearer " + JSON.parse(localStorage.getItem("token")),
                },
              }
            )
            .then(function (response) {
              const data = response.data;
              if (data.sucesso) {
                localStorage.setItem("token", JSON.stringify(data.token));
                self.close();
                self.$router.go();
              } else {
                self.notificao = data.mensagem;
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          self.go("Login");
        }
      }
    },
    close() {
      const self = this;

      self.notificao = "";
      self.cadastroModel.conta = null;
      self.dialog = false;
    },
    go: function (route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/compartilhados/Toolbar.vue